module.exports = __webpack_public_path__ + "img/play.2341e67f.svg";